/**
 * Les constantes de l'application
 * Afin d'uniformiser les constantes, on utilise le format :
 *
 * @example
 *  const {TYPE_CONSTANTE}_NOM_CONSTANTE = 'valeur';
 */

// Origine du dossier
export const ORIGIN_CLIENT_DEPUIS_CONTACT = 'CLIENT_DEPUIS_CONTACT' //  si le dossier est créé depuis une fiche contact et que le client est connecté
export const ORIGIN_CLIENT_DEPUIS_MAIL = 'CLIENT_DEPUIS_MAIL_CONTACT' //  si le dossier est créé depuis une fiche contact sans que le client ne soit connecté

export const ORIGIN_PUB_YOUTUBE = 'PUB_YOUTUBE' // si le dossier est créé en venant d'une campagne youtube
export const ORIGIN_PUB_FACEBOOK = 'PUB_FACEBOOK' // si le dossier est créé en venant d'une campagne facebook
export const ORIGIN_PUB_GOOGLE = 'PUB_GOOGLE' // si le dossier est créé en venant d'une campagne Google adsense

export const ORIGIN_PARTENAIRE_LIEN_TUNNEL = 'PARTENAIRE_LIEN_TUNNEL' //  Creation d'un nouveau dossier en venant d'un site partenaire
export const ORIGIN_PARTENAIRE_NEW = 'PARTENAIRE_NEW' // Creation d'un nouveau dossier arrivant depuis le BO partenaire dans le cas ou c'est un partenaire IOBSP
export const ORIGIN_PARTENAIRE_NEW_BO_PART_V2 = 'PARTENAIRE_NEW_BO_PART_V2' // Creation d'un nouveau dossier arrivant depuis le BO partenaire dans le cas ou c'est un partenaire IOBSP

export const ORIGIN_COURTIER_NEW = 'COURTIER_NEW' // Creation d'un nouveau dossier directement depuis le BO courtier
export const ORIGIN_COURTIER_DEPUIS_CONTACT = 'COURTIER_DEPUIS_CONTACT' // Creation d'un nouveau dossier depuis une fiche contact en provenance du BO courtier

export const ORIGIN_WAI_CALCULETTE = 'WAI_CALCULETTE' // Creation d'un nouveau dossier en provenance d'une des calculettes du widget
export const ORIGIN_WAI_DIRECT = 'WAI_DIRECT' // Creation d'un nouveau dossier directement depuis le BO

export const CP_HORS_FRANCE = '99000'
export const VILLE_HORS_FRANCE = 'HORS FRANCE'

export const MARQUES_BLANCHES = [
    {
        url_prefix: 'lamotte-financement.',
        cle: '200623-9HG2Q3',
    },
    {
        url_prefix: 'procivis-credit.',
        cle: '200629-EFALXB',
    },
    {
        url_prefix: 'cogir-financement.',
        cle: '220221-GA4T6A',
    },
    {
        url_prefix: 'pret-a-financer.',
        cle: '220321-DJJMEJ',
    },
]
